exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InfluencerJobShowPage .CampaignShowFull .CampaignImage {\n  margin: 0;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n@media (min-width: 640px) {\n.InfluencerJobShowPage .CampaignShowFull .CampaignImage {\n    border-radius: 0;\n    border-top-left-radius: 1rem;\n}\n}\n", ""]);

// exports
